export const sqConstants = {
    //end
    SQ_FETCHING: 'SQ_FETCHING',
    SQ_FETCHED: 'SQ_FETCHED',
    SQ_SUBMITTING: 'SQ_SUBMITTING',
    SQ_SUBMITTED: 'SQ_SUBMITTED',
    SQ_TERMS_GENERATING: 'SQ_TERMS_GENERATING',
    SQ_TERMS_GENERATED: 'SQ_TERMS_GENERATED',
    SQ_CHARGES_GENERATING: 'SQ_CHARGES_GENERATING',
    SQ_CHARGES_GENERATED: 'SQ_CHARGES_GENERATED',
    LIST_OF_SQ: 'LIST_OF_SQ',
    LIST_OF_SQ_AE_ARCHIVE: 'LIST_OF_SQ_AE_ARCHIVE',
    GET_SQ_BY_REFNUM: 'GET_SQ_BY_REFNUM',
    GET_TERMS_BY_CARGO_TYPE: 'GET_TERMS_BY_CARGO_TYPE',
    SQ_CHARGES: 'SQ_CHARGES',

    CLEAR_CHARGES: 'CLEAR_CHARGES',

    CLEAR_SQ: 'CLEAR_SQ',

    SQ_VIEWER: 'SQ_VIEWER',
    SQ_CUSTOMER_GROUP: 'SQ_CUSTOMER_GROUP',

    SQ_REPORTS_BOOKING: 'SQ_REPORTS_BOOKING',
    SQ_UPDATE: 'SQ_UPDATE',

    GET_SQ_WITH_AMEND: 'GET_SQ_WITH_AMEND',

    SQ_PRES_DATA: 'SQ_PRES_DATA',

    SQ_OPEN_VAN: 'SQ_OPEN_VAN',

    SQ_MEMORANDUM: 'SQ_MEMORANDUM',
    SQ_LIST_CHARGE: 'SQ_LIST_CHARGE',
    SQ_PROCEED_MEMO: 'SQ_PROCEED_MEMO',
    SQ_LIST_COMPANY_POLICY: 'SQ_LIST_COMPANY_POLICY',

    // Aging
    SQ_AGING_AE: 'SQ_AGING_AE',
    SQ_AGING_CUSTOMER_PER_AE: 'SQ_AGING_CUSTOMER_PER_AE',
    SQ_AGING_DATA: 'SQ_AGING_DATA',

    ALL_SQ_PER_CUSTOMER: 'ALL_SQ_PER_CUSTOMER',

    SQ_DEACTIVATE: 'SQ_DEACTIVATE',
    SQ_DEACTIVATED: 'SQ_DEACTIVATED',
    SQ_DEACTIVATE_LOG: 'SQ_DEACTIVATE_LOG',
}